import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const router = new Router({
	mode: 'history',
	routes: [
		{ //登录页，不依靠任何组件
			path: '/login/',
			component: resolve => require(['@/components/other/login.vue'], resolve),
			meta: {
				withoutAuth: true
			}
		},
		{ //核心页面，所有页面基本依赖于layout公共布局文件
			path: '',
			component: resolve => require(['@/components/other/layout'], resolve),
			children: [
				{ //默认页
					path: '/',
					redirect: { path: '/index/index' }
				},
				
				{ //首页
					path: '/index',
					component: resolve => require(['@/components/other/rightLayout'], resolve),
					children: [
						{
							path: 'index',
							component: resolve => require(['@/components/index/index'], resolve),
						},
						{
							path: 'set',
							component: resolve => require(['@/components/index/set'], resolve),
						},
						
					],
					props: {
						navPage: [
							{
								name: "数据分析",
								path: "/index/index",
							},
							{
								name: "配置",
								path: "/index/set",
							},
							
						]
					},
				},
				
				{ //用户
					path: '/user',
					component: resolve => require(['@/components/other/rightLayout'], resolve),
					children: [
						{
							path: 'index',
							component: resolve => require(['@/components/user/index'], resolve),
						},
						{
							path: 'detail',
							component: resolve => require(['@/components/user/detail'], resolve),
						},
					],
					props: {
						navPage: [
							{
								name: "用户",
								path: "/user/index",
							},
						]
					},
				},
				
				{ //资金
					path: '/capital',
					component: resolve => require(['@/components/other/rightLayout'], resolve),
					children: [
						{
							path: 'index',
							component: resolve => require(['@/components/capital/index'], resolve),
						},
						{
							path: 'detailed',
							component: resolve => require(['@/components/capital/detailed'], resolve),
						},
					],
					props: {
						navPage: [
							{
								name: "资金提现",
								path: "/capital/index",
							},
							{
								name: "明细",
								path: "/capital/detailed",
							},
						]
					},
				},
				
				{ //盲盒记录
					path: '/blindbox',
					component: resolve => require(['@/components/other/rightLayout'], resolve),
					children: [
						{
							path: 'index',
							component: resolve => require(['@/components/blindbox/index'], resolve),
						},
						{
							path: 'openRecord',
							component: resolve => require(['@/components/blindbox/openRecord'], resolve),
						},
						{
							path: 'saveRecord',
							component: resolve => require(['@/components/blindbox/saveRecord'], resolve),
						},
					],
					props: {
						navPage: [
							{
								name: "用户盲盒列表",
								path: "/blindbox/index",
							},
							{
								name: "开启记录",
								path: "/blindbox/openRecord",
							},
							{
								name: "存入记录",
								path: "/blindbox/saveRecord",
							},
						]
					},
				},
				
				{ //投诉记录
					path: '/complaint',
					component: resolve => require(['@/components/other/rightLayout'], resolve),
					children: [
						{
							path: 'index',
							component: resolve => require(['@/components/complaint/index'], resolve),
						},
					],
					props: {
						navPage: [
							{
								name: "投诉记录",
								path: "/complaint/index",
							},
						]
					},
				},
				
				
				
			]
		},
	]
})




router.beforeEach((to, from, next) => {
	let auth_key = localStorage.getItem('userInfo') || false;
	if (to.meta.withoutAuth) {
		next();
	} else {
		if (auth_key) {
			next();
		} else {
			next({
				path: '/login',
			});
		}
	}
});



export default router;



// WEBPACK FOOTER //
// ./src/router/index.js